import { render, staticRenderFns } from "./CalendarWorkload.vue?vue&type=template&id=67b89692"
import script from "./CalendarWorkload.vue?vue&type=script&lang=js"
export * from "./CalendarWorkload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports